import React, { Component } from 'react'
import get from 'lodash/get'

import BkFlowNavigationProfileMenuError from '../BkFlowNavigationProfileMenuError'

class BkFlowNavigationCendynProfileMenu extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			configData,
			profileUser,
			profileUserError,
			handleFetchProfileUser,
			closeMenuEvent
		} = this.props

		document.addEventListener('keydown',function(e){
			if (e.keyCode === 27) {
				closeMenuEvent()
			}
		})

		const hotelLabels = get(configData, 'hotel.labels[0]')

		let currentProfileUserName = null
		let	currentProfileUserTierUpgrade = null
		let	currentProfileUserNightsToUpgrade = null
		let profileCardClasses = 'bk-flow-navigation__profile-menu-card cendyn'

		if (profileUser) {
			if(profileUser.firstName) {
				currentProfileUserName = profileUser.firstName

				if (profileUser.lastName) {
					currentProfileUserName = profileUser.firstName + ' ' + profileUser.lastName
				}
			}

			if (profileUser.loyaltyTier) {
				profileCardClasses = 'bk-flow-navigation__profile-menu-card cendyn ' + profileUser.loyaltyTier.toLowerCase()
			}

			if (profileUser.loyaltyTierUpgrade) {
				currentProfileUserTierUpgrade = profileUser.loyaltyTierUpgrade
			}

			if (profileUser.nightsToUpgrade) {
				currentProfileUserNightsToUpgrade = profileUser.nightsToUpgrade
			}
		}

		const profileUserLoyaltyId = get(profileUser, 'loyaltyId')
		const profileUserLoyaltyIdPrefix = get(hotelLabels, 'profileUserLoyaltyIdPrefix')
		const profileUserLoyaltyTier = get(profileUser, 'loyaltyTier')
		const profileUserLoyaltyTierPrefix = get(hotelLabels, 'profileUserLoyaltyTierPrefix')

		return  (
			<div className="bk-flow-navigation__profile-menu">
				{ !profileUser &&
					profileUserError &&
					<BkFlowNavigationProfileMenuError
						hotelLabels={hotelLabels}
						handleFetchProfileUser={handleFetchProfileUser}
					/>
				}

				{ currentProfileUserName &&
					<h6>
						{ hotelLabels && hotelLabels.hello ? hotelLabels.hello : 'Hi' }, { currentProfileUserName }
						<button
							className="btn btn-text-only"
							onClick={() => closeMenuEvent()}
						>
							<i className="material-icons">close</i>
						</button>
				</h6>
				}

				{ currentProfileUserNightsToUpgrade &&
					currentProfileUserTierUpgrade &&
					<div className="bk-flow-navigation__profile-menu-card-upgrade">
						<p className="u-remove-margin">{ hotelLabels && hotelLabels.stay ? hotelLabels.stay : 'Stay' } {currentProfileUserNightsToUpgrade} { hotelLabels && hotelLabels.loyaltyNightsUntilMessage ? hotelLabels.loyaltyNightsUntilMessage : 'more nights until you reach' } {currentProfileUserTierUpgrade} { hotelLabels && hotelLabels.loyaltyIncreaseSavingsMessage ? hotelLabels.loyaltyIncreaseSavingsMessage : 'and increase your savings' }.</p>
					</div>
				}

				{profileUser &&
				!profileUserError &&
					<div className="bk-flow-navigation__profile-menu-card-actions">
						{process.env.REACT_APP_CRM_PROFILE_URL &&
							<button
								className="btn"
								onClick={() => window.location.replace(process.env.REACT_APP_CRM_PROFILE_URL)}
							>
								{hotelLabels && hotelLabels.myAccount ? hotelLabels.myAccount : 'My Account'}
							</button>
						}
					</div>
				}

				{ profileUserLoyaltyId &&
					<div className="bk-flow-navigation__profile-menu-card-details">
						<div className={profileCardClasses}>
							{profileUserLoyaltyTier &&
								<p className="u-font-bold tier">
									{
										profileUserLoyaltyTierPrefix
											? `${profileUserLoyaltyTierPrefix} ${profileUserLoyaltyTier}`
											: profileUserLoyaltyTier
									}
								</p>
							}
							{profileUserLoyaltyIdPrefix
								? (
									<p className="u-remove-margin u-font-bold">
										{profileUserLoyaltyIdPrefix} {profileUserLoyaltyId}
									</p>
								) : (
									<p className="u-remove-margin u-font-bold">
										N<sup>o</sup>: {profileUserLoyaltyId}
									</p>
								)
							}
						</div>
					</div>
				}

				<div className="bk-flow-navigation__profile-menu-card-logout">
					<button
						className="btn"
						onClick={() => window.location.replace(`${process.env.REACT_APP_CRM_PROFILE_URL}/account/profile`) }
					>
						{ hotelLabels && hotelLabels.signOut ? hotelLabels.signOut : 'Sign Out' }
					</button>
				</div>
			</div>
		)
	}
}

export default BkFlowNavigationCendynProfileMenu


// WEBPACK FOOTER //
// ./src/components/structure/navigation/profile/elements/BkFlowNavigationCendynProfileMenu.js